import React from 'react';
import wb0 from '../img/Detail/afraid_detail.jpg';
import './Detail.css';
const AfraidDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default AfraidDetail;